import { getTokenValue, token } from '@atlaskit/tokens';

export const colorSequence: {
	getValue: () => string;
}[] = [
	{ getValue: (): string => getTokenValue('color.chart.blue.bolder', '#0055CC') },
	{ getValue: () => getTokenValue('color.chart.green.bold', '#23A971') },
	{ getValue: () => getTokenValue('color.chart.yellow.bolder', '#FF9D00') },
	{ getValue: () => getTokenValue('color.chart.red.bold', '#FC552C') },
	{ getValue: () => getTokenValue('color.chart.purple.bolder', '#5A43D0') },
	{ getValue: () => getTokenValue('color.chart.blue.bold', '#247FFF') },
	{ getValue: () => getTokenValue('color.chart.green.boldest', '#055C3F') },
	{ getValue: () => getTokenValue('color.chart.yellow.bold', '#FFBE33') },
	{ getValue: () => getTokenValue('color.chart.red.boldest', '#A32000') },
	{ getValue: () => getTokenValue('color.chart.purple.bold', '#8B77EE') },
	{ getValue: () => getTokenValue('color.chart.blue.boldest', '#003884') },
	{ getValue: () => getTokenValue('color.chart.green.bolder', '#177D52') },
	{ getValue: () => getTokenValue('color.chart.yellow.boldest', '#9A6104') },
	{ getValue: () => getTokenValue('color.chart.red.bolder', '#D32D03') },
	{ getValue: () => getTokenValue('color.chart.purple.boldest', '#44368B') },
	// These colors don't have chart tokens since they're subtle colors - using 'color.background'
	{
		getValue: () => getTokenValue('color.background.accent.blue.subtle', '#7AB2FF'),
	},
	{
		getValue: () => getTokenValue('color.background.accent.green.subtle', '#6BE1B0'),
	},
	{
		getValue: () => getTokenValue('color.background.accent.yellow.subtle', '#FFDB57'),
	},
	{
		getValue: () => getTokenValue('color.background.accent.red.subtle', '#FF8F73'),
	},
	{
		getValue: () => getTokenValue('color.background.accent.purple.subtle', '#B5A7FB'),
	},
];

export const colorSequenceForExtendedChartsColorPicker: {
	getValue: () => string;
}[] = [
	{ getValue: (): string => getTokenValue('color.chart.blue.bolder', '#0055CC') }, // Dark blue
	{ getValue: () => getTokenValue('color.chart.green.bold', '#23A971') }, // Green
	{ getValue: () => getTokenValue('color.chart.yellow.bolder', '#FF9D00') }, // Dark yellow
	{ getValue: () => getTokenValue('color.chart.red.bold', '#FC552C') }, // Red
	{ getValue: () => getTokenValue('color.chart.purple.bolder', '#5A43D0') }, // Dark purple
	{ getValue: () => getTokenValue('color.chart.blue.bold', '#247FFF') }, // Blue
	{ getValue: () => getTokenValue('color.chart.green.boldest', '#055C3F') }, // Darker green
	{ getValue: () => getTokenValue('color.chart.yellow.bold', '#FFBE33') }, // Yellow
	{ getValue: () => getTokenValue('color.chart.red.boldest', '#A32000') }, // Darker red
	{ getValue: () => getTokenValue('color.chart.purple.bold', '#8B77EE') }, // Purple
	{ getValue: () => getTokenValue('color.chart.blue.boldest', '#003884') }, // Darker blue
	{ getValue: () => getTokenValue('color.chart.green.bolder', '#177D52') }, // Dark green
	{ getValue: () => getTokenValue('color.chart.red.bolder', '#D32D03') }, // Dark red
	{ getValue: () => getTokenValue('color.chart.purple.boldest', '#44368B') }, // Darker purple
	// These colors don't have chart tokens that are even close - using color.background
	{
		getValue: () => getTokenValue('color.background.accent.blue.subtle', '#7AB2FF'),
	}, // Light blue
	{
		getValue: () => getTokenValue('color.background.accent.green.subtle', '#6BE1B0'),
	}, // Light green
	{
		getValue: () => getTokenValue('color.background.accent.yellow.subtle', '#FFDB57'),
	}, // Light yellow
	{
		getValue: () => getTokenValue('color.background.accent.red.subtle', '#FF8F73'),
	}, // Light red
	{
		getValue: () => getTokenValue('color.background.accent.purple.subtle', '#B5A7FB'),
	}, // Light purple
	// new colors added
	{ getValue: () => getTokenValue('color.chart.teal.boldest', '#206B74') }, // Darker Teal
	{ getValue: () => getTokenValue('color.chart.orange.bold', '#D97008') }, // Orange
	{ getValue: () => getTokenValue('color.chart.yellow.boldest', '#9A6104') }, // Darker yellow
	{ getValue: () => getTokenValue('color.chart.magenta.bold', '#DA62AC') }, // Magenta
	{ getValue: () => getTokenValue('color.chart.orange.boldest', '#974F0C') }, // Darker orange
	{ getValue: () => getTokenValue('color.chart.gray.bold', '#8590A2') }, // Gray
	{ getValue: () => getTokenValue('color.chart.magenta.boldest', '#943D73') }, // Darker magenta
	{
		getValue: () => getTokenValue('color.background.accent.teal.subtle', '#60C6D2'),
	}, // Light teal
	{ getValue: () => getTokenValue('color.chart.gray.boldest', '#44546F') }, // Darker gray
	{
		getValue: () => getTokenValue('color.background.accent.orange.subtle', '#FAA53D'),
	}, // Light orange
	{ getValue: () => getTokenValue('color.chart.teal.bolder', '#1D7F8C') }, // Dark teal
	{
		getValue: () => getTokenValue('color.background.accent.magenta.subtle', '#E774BB'),
	}, // Light magenta
	{ getValue: () => getTokenValue('color.chart.orange.bolder', '#B65C02') }, // Dark orange
	{
		getValue: () => getTokenValue('color.background.accent.gray.subtler', '#8993A5'),
	}, // Light Gray
	{ getValue: () => getTokenValue('color.chart.magenta.bolder', '#CD519D') }, // Dark magenta
	{ getValue: () => getTokenValue('color.chart.gray.bolder', '#758195') }, // Dark gray
	{ getValue: () => getTokenValue('color.chart.teal.bold', '#1D9AAA') }, // Teal
];

// We need both versions of the sequence since you cannot use the `token()` function unless you directly pass in a string
export const tokenizedColorSequence: string[] = [
	token('color.chart.blue.bolder'),
	token('color.chart.green.bold'),
	token('color.chart.yellow.bolder'),
	token('color.chart.red.bold'),
	token('color.chart.purple.bolder'),
	token('color.chart.blue.bold'),
	token('color.chart.green.boldest'),
	token('color.chart.yellow.bold'),
	token('color.chart.red.boldest'),
	token('color.chart.purple.bold'),
	token('color.chart.blue.boldest'),
	token('color.chart.green.bolder'),
	token('color.chart.yellow.boldest'),
	token('color.chart.red.bolder'),
	token('color.chart.purple.boldest'),
	// These colors don't have chart tokens that are close since they're subtle colors - using 'color.background'
	token('color.background.accent.blue.subtle'),
	token('color.background.accent.green.subtle'),
	token('color.background.accent.yellow.subtle'),
	token('color.background.accent.red.subtle'),
	token('color.background.accent.purple.subtle'),
];
export const tokenizedExtendedColorSequence: string[] = [
	token('color.chart.blue.bolder'), // Dark blue
	token('color.chart.green.bold'), // Green
	token('color.chart.yellow.bolder'), // Dark yellow
	token('color.chart.red.bold'), // Red
	token('color.chart.purple.bolder'), // Dark purple
	token('color.chart.blue.bold'), // Blue
	token('color.chart.green.boldest'), // Darker green
	token('color.chart.yellow.bold'), // Yellow
	token('color.chart.red.boldest'), // Darker red
	token('color.chart.purple.bold'), // Purple
	token('color.chart.blue.boldest'), // Darker blue
	token('color.chart.green.bolder'), // Dark green
	token('color.chart.red.bolder'), // Dark red
	token('color.chart.purple.boldest'), // Darker purple
	// These colors don't have chart tokens - using color.background
	token('color.background.accent.blue.subtle'), // Light blue
	token('color.background.accent.green.subtle'), // Light green
	token('color.background.accent.yellow.subtle'), // Light yellow
	token('color.background.accent.red.subtle'), // Light red
	token('color.background.accent.purple.subtle'), // Light purple
	// new colors added
	token('color.chart.teal.boldest'), // Darker Teal
	token('color.chart.orange.bold'), // Orange
	token('color.chart.yellow.boldest'), // Darker yellow
	token('color.chart.magenta.bold'), // Magenta
	token('color.chart.orange.boldest'), // Darker orange
	token('color.chart.gray.bold'), // Gray
	token('color.chart.magenta.boldest'), // Darker magenta
	token('color.background.accent.teal.subtle'), // Light teal
	token('color.chart.gray.boldest'), // Darker gray
	token('color.background.accent.orange.subtle'), // Light orange
	token('color.chart.teal.bolder'), // Dark teal
	token('color.background.accent.magenta.subtle'), // Light magenta
	token('color.chart.orange.bolder'), // Dark orange
	token('color.background.accent.gray.subtler'), // Light Gray
	token('color.chart.magenta.bolder'), // Dark magenta
	token('color.chart.gray.bolder'), // Dark gray
	token('color.chart.teal.bold'), // Teal
];
